import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateStaff = () => {
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;
  const navigate = useNavigate();
  const [formState, setFormState] = useState({ honorifics: "mr", referredBy: "Admin" });
  const handleInput = ({ target: { name, value } }) => {
    setFormState((prev) => ({ ...prev, [name]: value }));
  };
  const handleCreateContact = async (e) => {
    e?.preventDefault();
    const { cPassword, ...staffMember } = formState;
    if (cPassword === staffMember?.password) {
      try {
        const { data } = await axios.post("", {
          action: "addStaff",
          companyId,
          ...staffMember,
        });
        if (data?.success) {
          setFormState({ honorifics: "mr", referredBy: "Admin" });
          toast.success(data?.msg);
          navigate("/staff");
        } else {
          toast.error(data?.error);
        }
      } catch (err) {
        console.error("ERROR:", err);
      }
    } else {
      toast.error("Confirm password doesn't match");
    }
  };

  return (
    <section>
      <h4>Create Staff Member </h4>
      <div className="card">
        <form onSubmit={handleCreateContact}>
          <div className="step row gy-4">
            <div className="col-md-6">
              <div className="d-flex">
                <select
                  name="role"
                  value={formState.role}
                  onChange={handleInput}
                  className="form-select"
                  placeholder="Role"
                  required
                >
                  <option value="">-- Select Role --</option>
                  <option value="3">Property Manage</option>
                  <option value="4">Lead</option>
                  <option value="5">Site Visit</option>
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="name"
                value={formState.name}
                onChange={handleInput}
                className="form-control"
                placeholder="Name"
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="tell"
                pattern="[0-9]{10}"
                name="phone"
                value={formState.phone}
                onChange={handleInput}
                className="form-control"
                placeholder="Phone number"
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="email"
                name="email"
                value={formState.email}
                onChange={handleInput}
                className="form-control"
                placeholder="Email address"
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="password"
                value={formState.password}
                onChange={handleInput}
                className="form-control"
                placeholder="Password"
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="cPassword"
                value={formState.cPassword}
                onChange={handleInput}
                className="form-control"
                placeholder="Confirm Password"
                required
              />
            </div>
          </div>
          <div className="d-flex  justify-content-end">
            <button type="submit" className="btn btn-primary">
              Create
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CreateStaff;
